// extracted by mini-css-extract-plugin
export default {"terms-info":"TermsAndConditions_terms-info__+EWUJ","termsWrapper":"TermsAndConditions_termsWrapper__NOczA"};